// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { SettingsCollectionModel } from "@insite/client-framework/Services/SettingsService";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";

export interface CustomSettingsCollectionModel extends SettingsCollectionModel {
    customSettings: {
        autoCompleteProductLimit: string;
        rootTrainingAndEventsCategoryUrl: string;
        cloudinaryBaseURL: string;
        cardTypes: string;
        quoteDateRange: string;
        youTubeApiKey: string;
        nonStockProductId: string;
        marketoFormScriptSrc: string;
        marketoHostName: string;
        defaultProductFallbackImage: string;
        addToWaitlistMarketoId: string;
        useKount: string;
        kountDeviceDataCollectorUrl: string;
        kountMerchantId: string;
        marketoContactUsFormId: string;
        useRealTimeOrderSubmit: string;
        toasterTimeoutInSeconds: string;
        checkReCaptchaForEventRegistrationOnClientSide: string;
        showBrandsAvailabilityTabs: string;
        pardotIntegrationType: string;
        addToWaitListPardotUrl: string;
        allowPeeriusUnhandledErrors: string;
        loginSubmitNotification: string;
        showShipCompleteButton: string;
        defaultValueForShipCompleteButton: string;
        disablePrintOptions: string;
    };
    optimizelyProductRecommendationSettings: {
        peeriusTrackingUrl: string;
        siteName: string;
        apiVersion: string;
        enablePeeriusRequestsConsoleLogs: string;
    };
}

export function getSettingsCollection(state: ApplicationState): CustomSettingsCollectionModel {
    return state.context.settings.settingsCollection as CustomSettingsCollectionModel;
}
